import { createSlice } from '@reduxjs/toolkit';
import { exportMovements, fetchMovements, fetchMovementsFilters } from './movementsThunks';
import { ALL_FILTER } from '../stock/stockConstants';
import { selectWarehouse } from '../warehouseContext/warehouseContextSlice';

export const INITIAL_MOVEMENTS_FILTERS = {
  /** SKU or product name. */
  search: '',
  /** Location name or code, partial. */
  slot: '',
  company: ALL_FILTER,
  movementType: ALL_FILTER,
  /** A user id as a string, `SYSTEM_ACTOR`, or "all". */
  actor: ALL_FILTER,
  dateFrom: '',
  dateTo: '',
  page: 1,
  rowsPerPage: 20,
};

const initialState = {
  rows: [],
  totalCount: 0,
  loading: false,
  error: null,
  filters: { ...INITIAL_MOVEMENTS_FILTERS },

  /** The "quién" options, as the server listed them. */
  actors: [],
  hasSystem: false,
  /** Walking the pages for the Excel. */
  exporting: false,
};

const movementsSlice = createSlice({
  name: 'movements',
  initialState,
  reducers: {
    /** Any filter but the page sends the listing back to page 1. */
    setMovementsFilters: (state, action) => {
      const { page, ...rest } = action.payload;
      state.filters = { ...state.filters, ...rest };
      state.filters.page = page ?? (Object.keys(rest).length ? 1 : state.filters.page);
    },
    clearMovementsFilters: (state) => {
      state.filters = { ...INITIAL_MOVEMENTS_FILTERS, rowsPerPage: state.filters.rowsPerPage };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMovements.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMovements.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload.results || [];
        state.totalCount = action.payload.count || 0;
      })
      .addCase(fetchMovements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.rows = [];
        state.totalCount = 0;
      })

      .addCase(fetchMovementsFilters.fulfilled, (state, action) => {
        state.actors = action.payload.actors || [];
        state.hasSystem = Boolean(action.payload.has_system);
      })
      // The listing still works without the options: the select just offers "Todos".
      .addCase(fetchMovementsFilters.rejected, (state) => {
        state.actors = [];
        state.hasSystem = false;
      })

      .addCase(exportMovements.pending, (state) => {
        state.exporting = true;
      })
      .addCase(exportMovements.fulfilled, (state) => {
        state.exporting = false;
      })
      .addCase(exportMovements.rejected, (state) => {
        state.exporting = false;
      })

      // Another warehouse is another floor: whoever was picked may not be there.
      .addCase(selectWarehouse, (state) => {
        state.filters.page = 1;
        state.filters.actor = ALL_FILTER;
      });
  },
});

export const { setMovementsFilters, clearMovementsFilters } = movementsSlice.actions;

export default movementsSlice.reducer;
